// src/pages/employer/EmployerMembers.jsx
import React from 'react';
import { Users } from 'lucide-react';

export const EmployerMembers = () => (
  <div className="fade-in">
    <div className="page-header">
      <h1>Members</h1>
      <p>Manage the user accounts and permissions for this profile.</p>
    </div>
    <div className="section-box">
      <div className="section-box-header">Members</div>
      <div className="section-box-body" style={{ color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: 10 }}>
        <Users size={16} />
        <span>Member management — coming soon.</span>
      </div>
    </div>
  </div>
);
